import BaseFactory from 'services/sports/default/base-factory';
import Const from 'constants';
import LpClassic from './lp-classic';
import LpSinglegame from './lp-singlegame';

const classesMap = {
    [Const.GAME_TYPE_CLASSIC]: LpClassic,
    [Const.GAME_TYPE_SINGLEGAME]: LpSinglegame,
};

class Factory extends BaseFactory {
    createObj(objectName, params) {
        const {sportConfig} = params;
        const gameType = sportConfig.getGameType();

        if (gameType in classesMap) {
            return new classesMap[gameType](params);
        }

        throw new Error(`Unknown gameType "${gameType}".`);
    }
}

export {Factory};
